<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'created_by',
                label: 'Created By',
                display: 'name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'created_at',
                label: 'Created Date',
                filter: 'localDateTime',
                sortable: true,
                searchable: false,
            },
            {
                value: 'pli_interval_value',
                label: 'PLI Interval',
                sortable: false,
                searchable: true,
                customCell: 'ConfigurationSetPliIntervalCell',
            },
            {
                value: 'frequency_set',
                label: 'Frequency Set',
                sortable: true,
                searchable: true,
                display: 'name',
                customCell: 'FrequencySetListCell',
            },
            {
                value: 'encryption_key',
                label: 'Encryption Key',
                sortable: true,
                searchable: true,
                display: 'name',
                filter: 'nullToNA',
            },
        ]"
        title="Configuration Sets"
        :model="'configuration-sets'"
        createText="Create"
        noResultsText="No Configuration Sets created"
        data-test-id="configuration-sets-table"
        defaultSort="created_at"
        :defaultDir="sortDirections.DESC"
        optionsComponent="ConfigurationSetActions"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import sortDirections from '@/constants/sort-directions'

export default {
    components: {
        IndexTable,
    },

    data() {
        return {
            sortDirections,
        }
    },
}
</script>
